import { Fragment } from 'react'
import { useIntl } from 'react-intl'

import mock from './subscriptionTableMock.json'
import {
  SubscriptionTableInnerContainer,
  SubscriptionTableOuterContainer,
  SubscriptionTableTitle,
} from './styles'
import SubscriptionTableHeader from './SubscriptionTableHeader'
import SubscriptionTableRow from './SubscriptionTableRow'
import { useAppSelector } from 'app/hooks'
import {
  subscriptionHomePriceSelector,
  userSubscriptionPlanSelector,
} from 'features/home/selectors'
import { subscriptionTableMessages } from './messages'
import { SpinnerContainer } from '../../HomeStatus/SubInfo/ConnectedApps/styles'
import { Spinner } from 'components/Loader'

function SubscriptionTable() {
  const { formatMessage } = useIntl()

  const plan = useAppSelector(userSubscriptionPlanSelector)
  const price = useAppSelector(subscriptionHomePriceSelector.data)

  const isPriceFetching = useAppSelector(
    subscriptionHomePriceSelector.isFetching
  )

  const isBasicHomePlan = plan.type !== 'none'
  const formattedPrice = price?.unit_amount / 100 ?? 0
  if (isPriceFetching) {
    return (
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    )
  }

  return (
    <>
      <SubscriptionTableTitle>
        {formatMessage(subscriptionTableMessages.title)}
      </SubscriptionTableTitle>
      <SubscriptionTableOuterContainer>
        <SubscriptionTableInnerContainer>
          <SubscriptionTableHeader
            isBasicHomePlan={isBasicHomePlan}
            price={formattedPrice}
          />
          {mock.map((row) => (
            <Fragment key={row.features}>
              <SubscriptionTableRow
                {...row}
                isBasicHomePlan={isBasicHomePlan}
              />
            </Fragment>
          ))}
        </SubscriptionTableInnerContainer>
      </SubscriptionTableOuterContainer>
    </>
  )
}

export default SubscriptionTable
